import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useLocation, useNavigate } from 'react-router-dom';
import Breadcrumb from '../../../component/common/Breadcrumb';
import SingleExerciseForm from '../../../component/HealthComponent/WorkoutForm/SingleExerciseForm';
import { getExerciseById } from '../../../api/healthAPI';
import { getLocalStorageItem, errorToast, successToast } from '../../../utils/helper';

const defaultExercise = {
  name: '',
  equipment_id: '',
  muscle_groups: [],
  exercise_duration: '',
  restTime: 10,
  video_url: '',
  image_url: ''
};

const NewExercise = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const id = new URLSearchParams(window.location.search).get('id');
  const userData = getLocalStorageItem('userData') && JSON.parse(getLocalStorageItem('userData'));

  const [exercise, setExercise] = useState(defaultExercise);
  const [loading, setLoading] = useState(!!id);

  const pages = [
    {
      name: 'Health Dashboard',
      href: `${userData?.slug ? `/${userData.slug}` : ''}/health/dashboard`
    },
    {
      name: 'Exercises',
      href: `${userData?.slug ? `/${userData.slug}` : ''}/health/exercises`
    },
    { name: id ? 'Edit Exercise' : 'New Exercise', current: true }
  ];

  useEffect(() => {
    if (id) {
      fetchExerciseById(id);
    }
  }, [id]);

  const fetchExerciseById = async (exerciseId) => {
    try {
      setLoading(true);
      const response = await getExerciseById(exerciseId);
      if (response?.meta?.code === 1 && response?.data) {
        const exerciseData = response.data;
        setExercise({
          name: exerciseData.name || '',
          equipment_id: exerciseData.equipment_id?._id || exerciseData.equipment_id || '',
          muscle_groups: exerciseData.muscle_groups || [],
          exercise_duration: exerciseData.exercise_duration || '',
          restTime: exerciseData.rest_time || 10,
          video_url: exerciseData.video_url || '',
          image_url: exerciseData.image_url || ''
        });
      } else {
        errorToast(response?.meta?.message || 'Failed to load exercise');
      }
    } catch (error) {
      errorToast('Failed to load exercise');
    } finally {
      setLoading(false);
    }
  };

  const handleSave = () => {
    successToast(id ? 'Exercise updated successfully' : 'Exercise created successfully');
    navigate(`${userData?.slug ? `/${userData.slug}` : ''}/health/exercises`);
  };

  const handleCancelEdit = () => {
    navigate(`${userData?.slug ? `/${userData.slug}` : ''}/health/exercises`);
  };

  return (
    <div className="relative lg:mb-[45px]">
      <Helmet>
        <meta charSet="utf-8" />
        <title>{id ? 'Edit Exercise' : 'New Exercise'} | Shoorah Admin</title>
      </Helmet>

      <Breadcrumb pageList={pages} className="lg:mt-8" />

      <div className="mt-6">
        {!loading && (
          <SingleExerciseForm
            exercise={exercise}
            onExerciseChange={setExercise}
            onSave={handleSave}
            onCancel={handleCancelEdit}
            isEditing={!!id}
            exerciseId={id}
            type="exercise"
          />
        )}
      </div>
    </div>
  );
};

export default NewExercise;
